
export const SubscriptionColumns = {
  INDEX: "#",
  ID: "ID",
  SERVICE: "SERVICE",
  USER: "User",
  NOTE: "Note",
  PLAN: "Plan",
  QUOTA: "Requests Used",
  TIME: "Started/Expired",
  TYPE_STATUS: "Type/Status",
  RENEW: "Auto Renew",
  ACTIONS: "Actions",
  SELECT: "Select",
};
const SubscriptionRow = (props) => {
  const {
    index = 0,
    sub = null,
    columns = [],
    onRenew = () => { },
    onChangeAutoRenew = () => { },
    onActionEdit = () => { },
    onActionDelete = () => { },
    onSelect = () => { },
    isSelected = false,
  } = props;
  const renderColumn = (column_name) => {
    switch (column_name) {
      case SubscriptionColumns.INDEX:
        return (
          <td className="border p-2">{index + 1}</td>
        )
      case SubscriptionColumns.ID:
        return (
          <td className="border p-2 sticky left-0 z-1 bg-white">{sub.id}</td>
        )
      case SubscriptionColumns.SERVICE:
        return (
          <td className="border p-2 break-keep max-w-[130px] text-base font-bold">{sub.service?.callback}</td>
        )
      case SubscriptionColumns.USER:
        return (
          <td className="border p-2 break-keep max-w-[200px]">{sub.username}(#{sub.user_id}) </td>
        )
      case SubscriptionColumns.NOTE:
        return (
          <td className="border p-2 max-w-[150px]">{sub.note}</td>
        )
      case SubscriptionColumns.PLAN:
        return (
          <td className="border p-2">
            <div className="gap-2 flex flex-col items-center">
              <div className="flex gap-2 border p-1 rounded-lg w-full">
                <span className="font-bold">Limit</span>
                <span>{sub.requests_limit}</span>
              </div>
              <div className="flex gap-2 border p-1 rounded-lg w-full">
                <span className="font-bold">Concurrency</span>
                <span>{sub.concurrency}</span>
              </div>
            </div>
          </td>
        )
      case SubscriptionColumns.QUOTA:
        let reqPercent = null;
        let reqText = null;
        if (!isNull(sub.requests_used) && !isNull(sub.requests_limit) && sub.requests_limit > 0) {
          reqPercent = (sub.requests_used / sub.requests_limit) * 100;
          reqText = `Remains ${sub.requests_remain} calls`;
        }
        let daysPercent = null;
        let daysText = null;
        if (!isNull(sub.expired_at) && !isNull(sub.started_at)) {
          const now = new Date();
          const expired = new Date(sub.expired_at + "Z");
          const daysRemain = (expired - now) / (1000 * 60 * 60 * 24);
          const totalDays = 31;
          const daysUsed = totalDays - daysRemain;
          daysPercent = (daysUsed / totalDays) * 100;
          daysText = `Remains ${daysRemain.toFixed(2)} days`;
          if (sub.cycles_remain > 0)
            daysText += ` (+${sub.cycles_remain * sub.duration_days})`;
        }
        return (
          <td className="border p-2 min-w-[220px] w-[220px]">
            <div className="space-y-2">
              <div className="relative w-full h-6 bg-gray-200 border border-gray-300 rounded overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full bg-green-300"
                  style={{
                    width: `${reqPercent}%`,
                    transition: "width 0.3s"
                  }}
                ></div>
                <div className="absolute inset-0 flex items-center justify-center text-black">
                  {reqText}
                </div>
              </div>
              <div className="relative w-full h-6 bg-gray-200 border border-gray-300 rounded overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full bg-blue-300"
                  style={{
                    width: `${daysPercent}%`,
                    transition: "width 0.3s"
                  }}
                ></div>
                <div className="absolute inset-0 flex items-center justify-center text-black">
                  {daysText}
                </div>
              </div>
            </div>
          </td>
        )
      case SubscriptionColumns.TIME:
        return (
          <td className="border p-2 min-w-[230px] w-[230px]">
            <div className="gap-2 flex flex-col items-center">
              <div className="flex flex-row border p-1 rounded-lg w-full gap-2">
                <span className="font-bold">Started</span>
                <span className="break-all">{new Date(sub.started_at).toLocaleString()}</span>
              </div>
              <div className="flex flex-row border p-1 rounded-lg w-full gap-2">
                <span className="font-bold">Expired</span>
                <span className="break-all">{new Date(sub.expired_at).toLocaleString()}</span>
              </div>
            </div>
          </td>
        )
      case SubscriptionColumns.TYPE_STATUS:
        return (
          <td className="border p-2 min-w-[100px] w-[100px]">
            <div className="flex flex-col gap-2 items-center">
              <div className={`flex border-2 p-1 rounded-lg w-20 items-center bg-${["blue-300 border-blue-500", "gray-300 border-gray-500"][sub.is_freemium]}`}>
                <span className="w-full text-center">{sub.is_freemium ? "Freemium" : "Paid"}</span>
              </div>
              <div className={`flex border-2 p-1 rounded-lg w-20 items-center bg-${["green-300 border-green-500", "yellow-500 border-yellow-700", "yellow-500 border-yellow-700"][sub.status]}`}>
                <span className="w-full text-center">{["Active", "Expired", "Reached Limit"][sub.status]}</span>
              </div>
            </div>
          </td>
        )
      case SubscriptionColumns.RENEW:
        return (
          <td className="border p-2">
            <div className="flex gap-1">
              <div className="w-48 flex flex-col items-start gap-1 pl-1">
                <div className="flex items-center gap-2 border p-1 rounded-lg w-full">
                  <button
                    className={`font-semibold px-2 py-1 rounded ${sub.is_renew_on_expired ? "bg-green-500 text-white hover:bg-gray-700" : "bg-gray-300 hover:bg-green-700"}`}
                    onClick={() => onChangeAutoRenew(sub.id, sub.is_renew_on_expired ? 0 : 1, sub.is_renew_on_reached_limit)}
                  >
                    {sub.is_renew_on_expired ? "ON" : "OFF"}
                  </button>
                  <span>On Expired</span>
                </div>
                <div className="flex items-center gap-2 border p-1 rounded-lg w-full">
                  <button
                    className={`font-semibold px-2 py-1 rounded ${sub.is_renew_on_reached_limit ? "bg-green-500 text-white hover:bg-gray-700" : "bg-gray-300 hover:bg-green-700"}`}
                    onClick={() => onChangeAutoRenew(sub.id, sub.is_renew_on_expired, sub.is_renew_on_reached_limit ? 0 : 1)}
                  >
                    {sub.is_renew_on_reached_limit ? "ON" : "OFF"}
                  </button>
                  <span>On Reached Limit</span>
                </div>
              </div>
              <button className="w-20 ml-1 text-lg font-semibold py-1 bg-blue-500 text-white rounded hover:bg-blue-700"
                onClick={() => onRenew(sub.requests_limit, sub.concurrency, sub.id, sub.is_freemium, sub.service_callback)}>
                Renew<br />
                <span className="text-sm">${sub.current_price.toFixed(2)}</span>
              </button>
            </div>
          </td>
        )
      case SubscriptionColumns.ACTIONS:
        return (
          <td className="border p-2">
            <div className="flex flex-col gap-2 justify-center items-center">
              <button
                onClick={() => onActionEdit(sub)}
                className="bg-yellow-500 text-black p-1 w-12 rounded text-xs sm:text-sm"
              >
                Edit
              </button>
              <button
                onClick={() => onActionDelete(sub.id)}
                className="bg-red-500 text-black p-1 w-12 rounded text-xs sm:text-sm"
              >
                Delete
              </button>
            </div>
          </td>
        )
      case SubscriptionColumns.SELECT:
        return (
          <td className="border p-2">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onSelect(sub, isSelected)}
              className="cursor-pointer w-6 h-6"
            />
          </td>
        )
      default:
        return null;
    }
  }
  const isNull = (value) => value === null;

  return (
    <tr key={index} className={`text-center border-4 text-sm`}>
      {columns.map((column_name, col_index) => (
        renderColumn(column_name)
      ))}
    </tr>
  )
}
export default SubscriptionRow;